import { getStringFromMessage } from '@lyrahealth-inc/shared-app-logic/src/features/intl/utils/getStringFromMessage'
import {
  DOMAIN_TO_TITLE,
  WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE,
  WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE_LIMIT,
} from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/constants'
import {
  WellbeingResponseResult,
  WellbeingResponseResults,
  WellnessCheckInResultsEssentialsContent,
} from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/types'

import { WELLBEING_RESULT_TO_CONTENT_MAPPING } from './wellnessCheckInDomainEssentialsConstants'
import { WellnessCheckInResultsEssentialsCarouselSlideContent } from '../../organisms/wellnessCheckInResultsEssentialsCarousel/WellnessCheckInResultsEssentialsCarousel'

/**
 * Translate number score to domain score
 * @param score
 */
export const translateWellnessCheckInNumberScoreToDomainScore = (
  score: number,
): WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE => {
  if (score <= WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE_LIMIT.LOW) {
    return WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE.LOW
  } else if (score <= WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE_LIMIT.MODERATE) {
    return WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE.MODERATE
  }

  return WELLNESS_CHECK_IN_RESULTS_DOMAIN_SCORE.HIGH
}

/**
 * Return the contents for low or high score
 * @param responseResults
 */
export const getWellnessCheckInEssentialsContents = (
  responseResults: WellbeingResponseResults,
): WellnessCheckInResultsEssentialsContent[] => {
  const contents: WellnessCheckInResultsEssentialsContent[] = []
  responseResults.forEach((result: WellbeingResponseResult) => {
    const facetGroup = result.facetGroup
    const wellbeingResult = result?.result
    if (facetGroup && wellbeingResult) {
      const faceGroupToContentMapping = WELLBEING_RESULT_TO_CONTENT_MAPPING[wellbeingResult]
      if (faceGroupToContentMapping) {
        const essentialContent: WellnessCheckInResultsEssentialsContent = faceGroupToContentMapping[facetGroup]
        if (essentialContent) {
          contents.push(essentialContent)
        }
      }
    }
  })

  return contents
}

/**
 * Get the mixpanel properties for the current slide content
 * @param currentSlideContent
 */
export const getWellnessCheckInResultsEssentialsCarouselSlideContent = (
  currentSlideContent: WellnessCheckInResultsEssentialsCarouselSlideContent,
) => {
  const itemsShown = currentSlideContent.articles.map((item) => {
    const subPathArr = item.subPath?.split('/') || []
    const destinationSlug = subPathArr.length > 0 ? subPathArr[subPathArr.length - 1] : ''
    return {
      item_type: getStringFromMessage(item.type),
      item_title: getStringFromMessage(item.title),
      destination_slug: destinationSlug,
      item_carousel_category: DOMAIN_TO_TITLE[currentSlideContent.domain],
    }
  })
  return itemsShown
}
